import { CUSTOM_TYPES_LIBRARY_DIRNAME } from "./constants.js";
const buildCustomTypeLibraryDirectoryPath = (args) => {
  return args.absolute ? args.helpers.joinPathFromRoot(CUSTOM_TYPES_LIBRARY_DIRNAME) : CUSTOM_TYPES_LIBRARY_DIRNAME;
};
export {
  buildCustomTypeLibraryDirectoryPath
};
//# sourceMappingURL=buildCustomTypeLibraryDirectoryPath.js.map
